/* eslint-disable import/prefer-default-export */
export function getSupportedMimeType(forMediaRecorder = false): string {
	const prioritizedMediaTypes = [
		forMediaRecorder ? 'video/webm;codecs=vp8,opus' : 'video/webm;codecs=vp8;codecs=opus',
		'video/webm;codecs=vp8',
		'video/mp4;codecs=vp8',
		'video/webm',
		'video/mp4'
	];

	for (let i = 0; i < prioritizedMediaTypes.length; i++) {
		const mediaType = prioritizedMediaTypes[i];
		if (MediaRecorder?.isTypeSupported(mediaType)) {
			return mediaType;
		}
	}

	// Default
	return 'video/mp4';
}
